import { Location } from '@cobliteam/common-types';

import { lazy } from '@cobliteam/lazy-with-retries';

const PerformancePage = lazy(() => import('../pages/PerformancePage'));
const PerformanceDashboardPage = lazy(() => import('../pages/PerformanceDashboardPage'));
const PerformanceDashboardLegacyPage = lazy(() => import('../pages/PerformanceDashboardLegacyPage'));
const PerformanceDashboardVehicleGroupPage = lazy(() => import('../pages/PerformanceDashboardVehicleGroupPage'));

export interface IRoute {
  path: string;
  component: any;
  accessDeniedDescription: string;
  routes?: IRoute[];
  exact?: boolean;
}

const routes: IRoute[] = [
  {
    path: Location.PRODUCTIVITY,
    component: PerformancePage,
    accessDeniedDescription: 'ver produtividade',
    routes: [
      {
        path: Location.PRODUCTIVITY_LEGACY,
        component: PerformanceDashboardLegacyPage,
        accessDeniedDescription: 'ver produtividade',
        exact: true,
      },
      {
        path: Location.PRODUCTIVITY_DASHBOARD,
        component: PerformanceDashboardPage,
        accessDeniedDescription: 'ver produtividade',
        exact: true,
      },
      {
        path: Location.PRODUCTIVITY_DASHBOARD_VEHICLE_GROUP,
        component: PerformanceDashboardVehicleGroupPage,
        accessDeniedDescription: 'ver produtividade',
        exact: true,
      },
    ],
  },
];

export default routes;
